module.exports = __webpack_public_path__ + "static/img/xitong.a4e047f7.png";